/** Reusable static call-to-actions shared across provider registries. */
import type { IssueCta } from "../provider-issue";

/** Meta WhatsApp Manager (account-wide). WABA-specific deep links are built by the consumer. */
export const META_WHATSAPP_MANAGER_CTA: IssueCta = {
  kind: "external",
  label: "Open Meta WhatsApp Manager",
  href: "https://business.facebook.com/wa/manage/"
};

/** In-app phone number settings, where Twilio connections and numbers are managed. */
export const PHONE_SETTINGS_CTA: IssueCta = {
  kind: "internal",
  label: "Open phone number settings",
  href: "/app/settings/phone-number"
};
